import {Pencil} from "lucide-react";
import React, {useState} from "react";
import {SessionData, SessionModal} from "./SessionModal";
import {useApiClient} from "../../../base/hooks/useApiClient";
import {useNavigate} from "react-router-dom";
import {Session} from "../../../../types";

interface Props {
    session: Session;
}

export function EditSessionButton({ session }: Props) {
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleEdit = async (sessionData: SessionData) => {
        const { name, originalLanguage, translationLanguages } = sessionData;

        const response = await apiClient.put(`sessions/${session.uuid}`, {
            name,
            originalLanguage,
            translationLanguages,
        });

        if (!response.ok) {
            return;
        }

        navigate(`/panel/sessions/${session.uuid}`);
        setIsModalOpen(false);
    };

    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                className="p-2 text-gray-400 hover:text-indigo-600 transition-colors"
            >
                <Pencil className="h-5 w-5" />
            </button>

            <SessionModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onSubmit={handleEdit}
                initialData={session}
            />
        </>
    );
}
